module.exports = __webpack_public_path__ + "img/logo-model-s.7d58a556.svg";